import React from "react";
import { Container } from "semantic-ui-react";
import VisualListItem from "./VisualListItem";

export default function VisualList({ cards }) {
  return (
    <Container>
      {cards.map((card) => (
        <VisualListItem card={card} key={card.id} />
      ))}
    </Container>
  );
}
